import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col, Table, Button, Modal, Form } from "react-bootstrap";
import LeadService from "../services/Lead";
import ModalComponent from "../component/ModalComponent";
import toast from "react-hot-toast";
import SelectDropDown from "../component/SelectDropDown";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import NoData from "../component/NoData";
import PurchaseService from "../services/Purchase";

const MySites = () => {
    
  const allStatus = [
    { id: "AcceptancePending", title: "Pending", pageNo: 1 },
    { id: "Accepted,Rejected", title: "Approved / Rejected", pageNo: 1 },
  ];
  const [loading, setLoading] = useState(true);
  const [mySiteData, setMySiteData] = useState([]);
  const [currentServiceData, setCurrentServiceData] = useState([]);
  const [serviceRejectReasonData, setServiceRejectReasonData] = useState([]);
  const [serviceAcceptReasonData, setServiceAcceptReasonData] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: "",
    title: "",
  });
  const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");
  const isHierDesc = userInfo?.dcm_hierarchies_id || null;
  console.log("isHierDesc---->", isHierDesc);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRejectReasonShow, setIsRejectReasonShow] = useState(false);
  const [isAcceptReasonShow, setIsAcceptReasonShow] = useState(false);
  const [evenCounter, setEvenCounter] = useState(0);
  const [showAlert, setShowAlert] = useState(false); // show success or error message on modal
  const [isLoginSuccessCondition, setIsLoginSuccessCondition] = useState("");
  const [isLoginSuccessText, setIsLoginSuccessText] = useState("");
  const [isLoginSuccessHeading, setIsLoginSuccessHeading] = useState("");
  const [showMore, setShowMore] = useState(true);
  const [status, setStatus] = useState(allStatus[0]);
  const [actionModal, setActionModal] = useState({ show: false, actionType: null, lead: null });
  const [actionReason, setActionReason] = useState("");
  const [isSubmittingAction, setIsSubmittingAction] = useState(false);
  const [isReasonList, setIsReasonList] = useState([]);
  const [actionReasonText, setActionReasonText] = useState("");
  // const [isReasonList, setIsReasonList] = useState([]);
  // const [actionReason, setActionReason] = useState("");
  const [isReason, setIsReason] = useState("");
  const [isReasonApproveValidator, setIsReasonApproveValidator] = useState("");
  const [isReasonApproveOtherValidator, setIsReasonApproveOtherValidator] = useState("");
  const [otherReason, setOtherReason] = useState("");

  //Format Date
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };

  const mySiteDataFetch = async () => {
    try {
      setLoading(true)
      const mySiteDataFetchResponse = await LeadService.getLeadsTSE(
        status.id
      );
      setLoading(false)
      if (mySiteDataFetchResponse.data.length == 0) {
        setShowMore(false);
        toast.error(status.pageNo == 1 ? "No sites found" : "No more sites");
        if(status.pageNo == 1) {
          setMySiteData([]);
        }
        return;
      } else {
        setShowMore(true);
      }
      if (
        mySiteDataFetchResponse.error == false &&
        mySiteDataFetchResponse.data.length > 0
      ) {
        const filteredData =
          mySiteDataFetchResponse.data.map((item, index) => {
            let serialNo = <div className="text-center">{index + 1}</div>;
            let statusElement;
            if (item.internal_status == "Accepted") {
              statusElement = (
                <div className="text-center approvedTxt">
                  <span
                    className={
                      isHierDesc == "TSE"
                        ? "w-100 approvedTxt d-inline-block"
                        : "m-150 approvedTxt d-inline-block"
                    }
                  >
                    Accepted
                  </span>
                </div>
              );
            } else if (item.internal_status == "Rejected") {
              statusElement = (
                <div className="text-center rejectedTxt">
                  <span
                    className={
                      isHierDesc == "TSE"
                        ? "w-100 rejectedTxt d-inline-block"
                        : "m-150 rejectedTxt d-inline-block"
                    }
                  >
                    Rejected
                  </span>
                </div>
              );
            }
            const projectAddress = [item.project_address_line1, item.project_address_line2]
              .filter(Boolean)
              .join(", ");
            const rowData = {
              serialNo: serialNo,
              leadNo: item.lead_id,
              createdDate: formatDate(item.created_at),
              customerType: item.customer_type,
              customerName: item.project_contact_person,
              siteName: item.project_name,
              siteAddress: projectAddress,
              constructionStatus: item.construction_status_name,
              constructionStage: item.construction_stage_name,
              noOfFloor: item.no_of_floor,
              customerContactNo: item.project_contact_phone_number,
              contractorName: item.full_name,
              contractorContactNo: item.number,
            };
            if (status.id === "AcceptancePending") {
              rowData.actions = (
                <div className="d-flex justify-content-center flex-nowrap">
                  <Button
                    size="sm"
                    variant="success"
                    className="me-2 text-nowrap rounded-0"
                    style={{ fontSize: "0.75rem", fontWeight: "normal" }}
                    onClick={() => handleApprove(item)}
                  >
                    Approve
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    className="text-nowrap rounded-0"
                    style={{ fontSize: "0.75rem", fontWeight: "normal" }}
                    onClick={() => handleReject(item)}
                  >
                    Reject
                  </Button>
                </div>
              );
            } else {
              rowData.status = statusElement;
            }
            return rowData;
          });
        if (filteredData.length == 0) {
          setShowMore(false);
          return;
        }
        
        if (status.pageNo == 1) setMySiteData(filteredData);
        if (status.pageNo > 1) setMySiteData((p) => [...p, ...filteredData]);
        setLoading(false);
      } else {
    
      }
    } catch (e) {
      // setLoading
      setLoading(false)
    } finally {
    }
  };
  useEffect(() => {
    mySiteDataFetch();
  }, [status]);

  const isPendingTab = status.id === "AcceptancePending";

  const handleApprove = (item) => {
    setActionReason("");
    setIsReason("accept");
    setActionModal({ show: true, actionType: "Accepted", lead: item });
  };

  const handleReject = (item) => {
    setActionReason("");
    setIsReason("reject");
    setActionModal({ show: true, actionType: "Rejected", lead: item });
  };

  const closeActionModal = () => {
    setActionModal({ show: false, actionType: null, lead: null });
    setActionReason("");
  };

  const submitAction = async () => {
    // if (!actionReason.trim()) {
    //   toast.error("Please enter a reason");
    //   return;
    // }
    try {
      setIsSubmittingAction(true);
      const payload = {
        internal_status: actionModal.actionType,
        lead_id: parseInt(actionModal.lead.id),
        remarks: actionReason.trim(),
      };
      const response = await LeadService.acceptRejectLead(payload);
      if (response.error == false) {
        toast.success(response.apiResponse || "Lead updated successfully");
        closeActionModal();
        setStatus((p) => ({ ...p, pageNo: 1 }));
      } else {
        toast.error(response.errorMessage || "Something went wrong");
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsSubmittingAction(false);
    }
  };

  function onLoadMore() {
    setStatus((p) => ({ ...p, pageNo: p.pageNo + 1 }));
  }
  const columnLabels = {
    serialNo: "S.No",
    leadNo: "Lead No",
    createdDate: "Created Date",
    customerType: "Customer Type",
    customerName: "Customer Name",
    siteName: "Site Name",
    siteAddress: "Site Address",
    constructionStatus: "Construction Status",
    constructionStage: "Construction Stage",
    noOfFloor: "No. Of Floors",
    customerContactNo: "Customer Contact No.",
    contractorName: "Contractor Name",
    contractorContactNo: "Contractor Contact No",
    actions: "Actions",
    status: "Status",
  };
  let headers = [];
  if (mySiteData.length > 0) {
    headers = Object.keys(mySiteData[0]);
  }

  useEffect(() => {
  const reasonDataFetch = async () => {
    try {
      if (isReason) {
        console.log("isReason----->", isReason);
        console.log("isHierDesc----->", isHierDesc);
        const reasonDataResponse =
          await PurchaseService.reasonsApprovalAndRejection(
            isReason,
            // isHierDesc
            20
          );
        console.log("reasonDataResponse----->", reasonDataResponse);
        if (reasonDataResponse.success === true) {
          const reason = reasonDataResponse.response.reasonsList?.map(
            (item) => ({
              id: item.id,
              title: item.reasons,
            })
          );
          setIsReasonList(reason || []);
        }
      }
    } catch (error) {
      console.error("Reason Data Fetch", error);
    }
  };

  reasonDataFetch();
}, [isReason, isHierDesc]);

  return (
    <>
      {/* {loading && <Loader />} */}

      {isHierDesc == "TSE" && (
        <BreadCrumbSecttion
          pageTitle="Site Approval"
          currentPageName="Site Approval"
        />
      )}
      <section className="padTop50">
        {/* {allMarked.length > 0 && (
          <Button className="float-footer" onClick={approveAll}>
            Approve All
          </Button>
        )} */}
        <Container>
          <Row>
            <Col xs={12} lg={12}>
              <div className="searchBoxBlock my-4">
                <Row>
                  <Col xs={12} lg={3}>
                    <SelectDropDown
                      labelName="Filter by status"
                      // requiredStar="*"
                      options={allStatus}
                      setSelectedValue={setStatus}
                      selectedValue={status}
                      // onChange={handleContentDistrictNameChange}
                      page="searchFilter"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {mySiteData.length == 0 && !loading && <NoData /> }
              {mySiteData.length === 0 && loading && <NoData title="Fetching..." />}
              {mySiteData.length > 0 && <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    {headers.length > 0 &&
                      headers.map((header, index) => (
                        <th key={index}>{columnLabels[header] || header}</th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {mySiteData.length > 0 &&
                    mySiteData.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <div>{item.leadNo}</div>
                          </td>
                          <td>
                            <div>{item.createdDate}</div>
                          </td>
                          <td>
                            <div>{item.customerType}</div>
                          </td>
                          <td>
                            <div>{item.customerName}</div>
                          </td>
                          <td>
                            <div>{item.siteName}</div>
                          </td>
                          <td>
                            <div>{item.siteAddress}</div>
                          </td>
                          <td>
                            <div>{item.constructionStatus}</div>
                          </td>
                          <td>
                            <div>{item.constructionStage}</div>
                          </td>
                          <td>
                            <div>{item.noOfFloor}</div>
                          </td>
                          <td>
                            <div>{item.customerContactNo}</div>
                          </td>
                          <td>
                            <div>{item.contractorName}</div>
                          </td>
                          <td>
                            <div>{item.contractorContactNo}</div>
                          </td>
                          <td>
                            <div>{isPendingTab ? item.actions : item.status}</div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>}
              {/* {visibleItemCount < data.length && ( */}

              {/* {showMore && ( */}
               {/* { mySiteData.length > 0 && !loading && mySiteData.length % 30 === 0 && <Container>
                  <Row className="justify-content-center">
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        disabled={!showMore}
                        onClick={onLoadMore}
                        buttonText="Show More"
                      />
                    </Col>
                  </Row>
                </Container>} */}
                {mySiteData.length > 0 && mySiteData.length % 30 === 0 && (
                  loading ? (
                    <Container>
                  <Row className="justify-content-center">
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        buttonText="Loading..."
                      />
                    </Col>
                  </Row>
                </Container>
                  ) : (
                    <Container>
                  <Row className="justify-content-center">
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        disabled={!showMore}
                        onClick={onLoadMore}
                        buttonText="Show More"
                      />
                    </Col>
                  </Row>
                </Container>
                  )
                )}
              {/* )} */}
            </Col>
          </Row>

          <Col xs={12}>
            <ModalComponent
              // onHide={onHide}
              page="myService"
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              serviceRejectReasonData={serviceRejectReasonData}
              serviceAcceptReasonData={serviceAcceptReasonData}
              serviceApproval={currentServiceData}
              outlinebuttonText="I Understood"
              onClick={""}
              modalTitle="Service Approval"
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              isRejectReasonShow={isRejectReasonShow}
              setIsRejectReasonShow={setIsRejectReasonShow}
              isAcceptReasonShow={isAcceptReasonShow}
              setIsAcceptReasonShow={setIsAcceptReasonShow}
              // handleApprove={handleApprove}
              // handleRejectReasonOnChange={handleRejectReasonOnChange}
              showAlert={showAlert}
              isLoginSuccessText={isLoginSuccessText}
              isLoginSuccessCondition={isLoginSuccessCondition}
              isLoginSuccessHeading={isLoginSuccessHeading}
            />
          </Col>

          <Modal show={actionModal.show} onHide={closeActionModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>
                {actionModal.actionType === "Accepted" ? "Approve Lead" : "Reject Lead"}
              </Modal.Title>
            </Modal.Header>
            {/* <Modal.Body>
              <Form.Group>
                <Form.Label>Reason</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={actionReason}
                  onChange={(e) => setActionReason(e.target.value)}
                  placeholder="Enter reason"
                />
              </Form.Group>
            </Modal.Body> */}
            <Modal.Body>
              <Form.Group>
                <Form.Label>Reason</Form.Label>

                  <Form.Select
                    value={actionReason}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedReason = isReasonList?.find(
                        (item) => String(item.id) === String(selectedId)
                      );
                    setActionReason(selectedId);
                    setActionReasonText(selectedReason?.title || "");
                  }}>
                    <option value="">Select Reason</option>
                    {isReasonList?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </Form.Select>
              </Form.Group> 

              {isReasonList?.find(
                  (item) => String(item.id) === String(actionReason)
                )?.title?.toLowerCase() === "others" && (
                <Form.Group className="mt-3">
                  <Form.Label>Others</Form.Label>
                  <Form.Control
                    type="text"
                    value={otherReason}
                    onChange={(e) => setOtherReason(e.target.value)}
                    placeholder="Enter reason"
                  />
                  </Form.Group>
                )}

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeActionModal} disabled={isSubmittingAction}>
                Cancel
              </Button>
              <Button
                variant={actionModal.actionType === "Accepted" ? "success" : "danger"}
                onClick={submitAction}
                disabled={isSubmittingAction}
              >
                {isSubmittingAction ? "Submitting..." : "Submit"}
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </section>
    </>
  );
};

export default MySites;
